export default __webpack_public_path__ + "static/media/icon-overview-grey.1cb7776e.svg";